import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { COUNTRIES } from '@/lib/constants';
import { DropdownPicker } from '../dropdown-picker';

export const DropdownCountries: FC<
  Omit<
    ComponentProps<typeof DropdownPicker>,
    'data' | 'emptyLabel' | 'selectAllLabel' | 'control' | 'search'
  >
> = (props) => {
  const { t } = useTranslation();
  const countries = [...COUNTRIES];

  return (
    <DropdownPicker
      {...props}
      // selectAllLabel={t('label.allCountries')}
      emptyLabel={t('label.country')}
      data={countries}
      control="checkbox"
      search
      maxSelected={3}
    />
  );
};
